module.exports = __webpack_public_path__ + "img/desktop-neck-3_18x432.a743e624.png";